import React from "react";
import ReportEmailActions from "./ReportEmailActions.jsx";
import { defaultReportEmailItem, REPORT_EMAIL_LABELS } from "../utils/reportEmailForm.js";

export const DashboardReportContext = React.createContext(null);
// Stable indicator identity, independent of the heading used by its day view.
export const DashboardIndicatorContext = React.createContext(null);
const KEYS_BY_TITLE = Object.fromEntries(Object.entries(REPORT_EMAIL_LABELS).map(([key, title]) => [title, key]));
KEYS_BY_TITLE["Occupation et flotte"] = "occupation";
KEYS_BY_TITLE["Tonnage du dispatch"] = "tonnage";

export default function DashboardReportActions({ title, keys = null, label = "" }) {
  const selection = React.useContext(DashboardReportContext);
  const indicatorKey = React.useContext(DashboardIndicatorContext);
  const resolvedKeys = keys || [indicatorKey || KEYS_BY_TITLE[title]].filter(Boolean);
  if (!selection || !resolvedKeys.length) return null;
  const options = selection.period === "day" ? { date_mode: "yesterday" } : selection.date
    ? { date_mode: "fixed", fixed_date: selection.date } : { date_mode: "today" };
  return <ReportEmailActions compact={!label} label={label || undefined} items={resolvedKeys.map((key) => defaultReportEmailItem("dashboard", key, {
    ...options, period: selection.period, dispatch_period: selection.dispatchPeriod || "day",
  }))} />;
}
